<header class="shadow rounded bg-light">
  <div class="row">
    <div class="col">
      <img
        [ngSrc]="logo"
        class="img-fluid"
        alt="AL header logo picture"
        height="170"
        width="102"
      />
    </div>
    <div class="col-8 text-center">
      <h1 class="fw-bold">
        Online Application for AL HIPP -
        <br />
        Alabama Health Insurance Premium Payment Program
      </h1>
      <strong>Fill out this form. Then click Submit to send it to us.</strong>
      <p>
        If you prefer to download an Alabama HIPP program Application
        <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openPaperApplication()">click here</a>
      </p>
    </div>
    <div class="col-2"></div>
  </div>
</header>
<br />
<main>
  <app-alform
    [preference]="preference"
    [errorMessageIntialData]="errorMessageIntialData"
    [email]="email"
    [mailingAddress]="mailingAddress"
    [emailTo]="emailTo"
    [faxNo]="faxNo"
    [tollfreeNo]="tollfreeNo"
    [dropingAddress]="dropingAddress"
    [mailingOffice]="mailingOffice"
    [mailingAddressLine]="mailingAddressLine"
    [mailingCityStateZip]="mailingCityStateZip"
  ></app-alform>
</main>
<br />
<footer class="text-center bg-light">
  <p>
    Email
    <a
      target="_blank"
      [href]="emailTo"
      alt="Email"
      title="email"
      lang="en"
      style="color: #0c69f2"
      >{{ email }}</a
    >
    | Fax {{ faxNo }} | Phone {{ tollfreeNo }} | Mail to {{ mailingAddress }}
  </p>
  <div class="text-dark p-3 bg-secondary bg-opacity-50 bg-gradient">
    HMS, Inc. All Rights Reserved
  </div>
</footer>

<al-app-scroll-top></al-app-scroll-top>
